import { toastQueue } from './toast-queue.ts';

export function removeToast(...args: Parameters<typeof toastQueue.close>) {
  toastQueue.close(...args);
}
export const addToast = (...args: Parameters<typeof toastQueue.add>) => toastQueue.add(args[0], { timeout: 5000, ...args[1] });
